export const applicantDocumentIds = {
  privacy: 'unitfield-applicant-privacy-notice',
  electronicRecords: 'unitfield-electronic-records-consent',
  terms: 'unitfield-rental-application-terms',
} as const;
export interface ApplicantLegalDocument { id: string; version: string; contentSha256: string; url: string }
export interface ApplicantLegalProjection { legalReady: boolean; unavailableReason: string | null; documents: ApplicantLegalDocument[]; certification: { text: string; textSha256: string } | null }
export const unavailableApplicantLegal = (): ApplicantLegalProjection => ({ legalReady: false, unavailableReason: 'publication-unavailable', documents: [], certification: null });
